import * as React from 'react'
import {
  WrappedFieldProps,
  Field,
  GenericField,
  BaseFieldProps
} from 'redux-form'
import { FormControl } from 'react-bootstrap'
import ControlWrapper from './ControlWrapper'

export interface InputControlCustomProps {
  type: string
  placeholder?: string
}

export type InputControlProps = WrappedFieldProps & InputControlCustomProps

const InputControl: React.SFC<InputControlProps> = props => {
  const { input, label, meta, type, placeholder } = props

  return (
    <ControlWrapper label={label} meta={meta}>
      <FormControl {...input} data-test={input.name} type={type} placeholder={placeholder} />
    </ControlWrapper>
  )
}

const CustomField = Field as new () => GenericField<InputControlCustomProps>

export type InputControlFieldProps = BaseFieldProps<InputControlCustomProps> &
  InputControlCustomProps

export const InputControlField: React.SFC<InputControlFieldProps> = props => (
  <CustomField {...props} component={InputControl} />
)

export default InputControl



// WEBPACK FOOTER //
// ./src/components/form/InputControl.tsx